export default class Category {
  constructor(public brand: string = '', public name: string = '', public icon: string = '', public categories: SubCategory[] = []) { }
}

export class SubCategory {
  constructor(public name: string = '', public games: string[] = []) { }
}
